import { PageContent } from "@/shared/widgets/layout/PageContent";
import { useNavigate } from "react-router-dom";
import { Button } from "@/shared/ui/button";
import { PlusIcon, ArrowUpDown } from "lucide-react";
import CategoriesList from "./CategoriesList";
import { useState } from "react";
import { CategoryOrderModal } from "./CategoryOrderModal";
import { useAllCategoriesData } from "@/features/categories/hooks/useCategoriesData";
import { useCategoryOrder } from "@/features/categories/hooks/useCategoryOrder";
import { Category } from "@/features/categories/service/categoryService";
import { useTranslation } from "@/shared/i18n";

const CategoriesIndex = () => {
    const { t } = useTranslation('categories');
    const navigate = useNavigate();
    const [isOrderModalOpen, setIsOrderModalOpen] = useState(false);
    const { data: allCategoriesData, isLoading: isLoadingAll } = useAllCategoriesData();
    const { saveOrder, isSaving } = useCategoryOrder();

    // Filtra apenas categorias do tipo PRESET
    const allCategories = (allCategoriesData?.data || []).filter(
        (cat) => cat.type === "PRESET"
    );

    const handleSaveOrder = async (
        orderedCategories: Category[],
        removedCategoryIds: string[]
    ) => {
        await saveOrder(orderedCategories, removedCategoryIds);
        setIsOrderModalOpen(false);
    };

    const actions = (
        <div className="flex gap-2">
            <Button
                variant="outline"
                onClick={() => setIsOrderModalOpen(true)}
                className="bg-[#333333] text-white border-[#444444] hover:bg-[#444444]"
            >
                <ArrowUpDown className="h-4 w-4 mr-2" />
                {t('sortCategories')}
            </Button>
            <Button onClick={() => navigate("/categories/new")}>
                <PlusIcon className="h-4 w-4 mr-2" />
                {t('newCategory')}
            </Button>
        </div>
    );

    return (
        <>
            <PageContent
                title={t('categories')}
                items={[
                    {
                        label: t('home'),
                        href: "/",
                    },
                    {
                        label: t('categories'),
                        href: "/categories",
                    },
                ]}
                actions={actions}
            >
                <div className="rounded-lg overflow-hidden">
                    <CategoriesList />
                </div>
            </PageContent>

            <CategoryOrderModal
                open={isOrderModalOpen}
                onOpenChange={setIsOrderModalOpen}
                categories={allCategories}
                onSave={handleSaveOrder}
                isSaving={isSaving}
            />
        </>
    );
};

export default CategoriesIndex;